import React, { useState } from 'react';
import ReactPaginate from 'react-paginate';

function Pager({ totalItems, itemsPerPage, activePage, handlePageClick }) {
  // const [itemOffset, setItemOffset] = useState(0);
  // const endOffset = itemOffset + itemsPerPage;
  // console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  
  const pageCount = Math.ceil(totalItems / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageChange = (event) => {
    // const newOffset = (event.selected * itemsPerPage) % totalItems;
    // setItemOffset(newOffset);
    handlePageClick(event);
  };

  if (pageCount <= 1) {
    return null;
  }

  return (
    <ReactPaginate
      breakLabel="..."
      containerClassName="pager"
      nextLabel="Next"
      forcePage={activePage}
      marginPagesDisplayed={0}
      onPageChange={handlePageChange}
      pageRangeDisplayed={5}
      pageCount={pageCount}
      previousLabel="Previous"
      renderOnZeroPageCount={null}
      previousClassName='link-breadcrumb'
      nextClassName='link-primary'
    />
  );
}

export default Pager;
